import { MatterFileType } from '@models/matter';
import { Selector } from '@ngxs/store';
import { SelectedMatter } from '../matter.selectors';

export class MatterWordDocumentsDefaultsSource {
	@Selector([SelectedMatter.matterFileType])
	static getStatementOfAccountDocumentSourceIdByMatterType(
		matterType: MatterFileType,
	): string {
		if (
			[
				MatterFileType.PURCHASE,
				MatterFileType.REFINANCE,
				MatterFileType.SALE,
			].includes(matterType)
		) {
			return 'SoA_spr';
		}

		return null;
	}

	@Selector([SelectedMatter.matterFileType])
	static getStatementOfAdjustmentsSourceIdByMatterType(
		matterType: MatterFileType,
	): string {
		if (matterType === MatterFileType.PURCHASE) {
			return 'SoA_p';
		}

		if (matterType === MatterFileType.REFINANCE) {
			return null;
		}

		if (matterType === MatterFileType.SALE) {
			return `SoA_s`;
		}
	}

	@Selector([SelectedMatter.matterFileType])
	static getTrustLedgerSourceIdByMatterType(
		matterType: MatterFileType,
	): string {
		if (
			[
				MatterFileType.PURCHASE,
				MatterFileType.REFINANCE,
				MatterFileType.SALE,
			].includes(matterType)
		) {
			return 'TL_spr';
		}

		return null;
	}

	@Selector([SelectedMatter.matterFileType])
	static getUndertakingsSourceIdByMatterType(
		matterType: MatterFileType,
	): string {
		if (matterType === MatterFileType.SALE) {
			return 'UG_s';
		}

		if (matterType === MatterFileType.REFINANCE) {
			return 'UGAfMEM_r';
		}

		return null;
	}

	@Selector([SelectedMatter.matterFileType])
	static getRequisitionsSourceIdByMatterType(
		matterType: MatterFileType,
	): string {
		if (matterType === MatterFileType.PURCHASE) {
			return 'RL_p';
		}

		return null;
	}

	@Selector([SelectedMatter.matterFileType])
	static getResponseToRequisitionsSourceIdByMatterType(
		matterType: MatterFileType,
	): string {
		if (matterType === MatterFileType.SALE) {
			return 'RtR_s';
		}

		return null;
	}
}
